module.exports = __webpack_public_path__ + "img/jumbotron_bottom.06cb1202.png";